module.exports = {
   REACT_APP_API_URL: process.env.REACT_APP_API_URL,
   REACT_APP_BASE_URL: process.env.REACT_APP_BASE_URL,
   REACT_APP_CASHFREE_URL: process.env.REACT_APP_CASHFREE_URL,
   REACT_APP_HEADER_ORG: process.env.REACT_APP_HEADER_ORG,
}